export const SIGNUP_BANNER_MIN_VISITS = 4;
export const SIGNUP_INVITE_VISIT_STORAGE_KEY = 'signupInviteVisitCountV2';

/**
 * Normalise le compteur dedie a la banniere d'inscription.
 */
export const normalizeSignupInviteVisitCount = (value) => {
  const parsedValue = parseInt(value || '0', 10);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : 0;
};

/**
 * Calcule le compteur apres l'ouverture de session courante.
 *
 * Les anciens compteurs globaux de visite ne sont volontairement pas repris:
 * cette banniere doit attendre quatre sessions dediees avant affichage.
 */
export const getSignupInviteVisitCountAfterSessionStart = ({
  storedVisitCount,
  sessionAlreadyCounted
}) => {
  const currentVisitCount = normalizeSignupInviteVisitCount(storedVisitCount);
  return sessionAlreadyCounted ? currentVisitCount : currentVisitCount + 1;
};

/**
 * Indique si l'engagement local permet d'afficher la bannière d'inscription.
 * Le seuil correspond à la troisième revisite: visite initiale + 3 retours.
 */
export const shouldShowSignupInviteBannerForEngagement = ({ visitCount }) => {
  return Number.isFinite(visitCount) && visitCount >= SIGNUP_BANNER_MIN_VISITS;
};
